import "core-js/modules/es.array.reverse.js";
var _dec, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import ModelTraits from "../ModelTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
let HighlightColorTraits = (_dec = primitiveTrait({
  name: "Highlight color",
  type: "string",
  description: "The color used to highlight a feature when it is picked. If not set, this defaults to `Terria.baseMapContrastColor`"
}), _class = class HighlightColorTraits extends ModelTraits {
  get highlightColor() {
    return;
  }
}, _applyDecoratedDescriptor(_class.prototype, "highlightColor", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "highlightColor"), _class.prototype), _class);
export { HighlightColorTraits as default };